module.exports = __webpack_public_path__ + "img/gray-insta-icon.8875de19.svg";